import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateSupplierForm from '../../forms/CreateOrUpdateSupplierForm'

const CreateSupplierModal: React.FC<{
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}> = ({ open, onClose, loading, error }) => (
  <AppModal open={open} onClose={onClose} title="Add Supplier" width="md" loading={loading}>
    <CreateOrUpdateSupplierForm loading={loading} error={error} />
  </AppModal>
)

export default CreateSupplierModal
